import {on} from "../util";

declare const eo_version : string;

export default class {
    static init = () => {
        paperdoll();
    }
}

function paperdoll() {
    let container = document.querySelector('.eo-ppd') as HTMLElement;
    if(!container) {
        return;
    }

    on('change', '.js-eo-ppd-select-race', () => {
        update_race_image();
    });

    on('change', '.js-eo-ppd-select-gender', () => {
        update_race_image();
        update_hair_image();
        update_hat_image();
        update_clothing_image();
        update_boots_image();
        update_weapon_image();
        update_shield_image();
    });

    on('change', '.js-eo-ppd-select-direction', () => {
        update_race_image();
        update_hair_image();
        update_hat_image();
        update_clothing_image();
        update_boots_image();
        update_weapon_image();
        update_shield_image();
    });

    on('change', '.js-eo-ppd-select-hair', () => {
        update_hair_image();
    });

    on('change', '.js-eo-ppd-select-color', () => {
        update_hair_image();
    });

    on('change', '.js-eo-ppd-select-hat', () => {
        update_hat_image();
    });

    on('change', '.js-eo-ppd-select-clothing', () => {
        update_clothing_image();
    });

    on('change', '.js-eo-ppd-select-boots', () => {
        update_boots_image();
    });

    on('change', '.js-eo-ppd-select-weapon', () => {
        update_weapon_image();
    });

    on('change', '.js-eo-ppd-select-shield', () => {
        update_shield_image();
    });

    let ppdContainer = document.querySelector('.eo-ppd') as HTMLElement;
    ppdContainer.addEventListener('click', () => {
        let directionSelect = document.querySelector('.js-eo-ppd-select-direction') as HTMLSelectElement;
        let direction = parseInt(directionSelect.value);
        direction = (direction + 1) % 4;
        directionSelect.value = direction.toString();
        directionSelect.dispatchEvent(new Event('change'));
    });

    let race = document.querySelector('.eo-ppd-race') as HTMLImageElement;
    let hair = document.querySelector('.eo-ppd-hair') as HTMLImageElement;
    let hat = document.querySelector('.eo-ppd-hat') as HTMLImageElement;
    let hatUnder = document.querySelector('.eo-ppd-hat-under') as HTMLImageElement;
    let clothing = document.querySelector('.eo-ppd-clothing') as HTMLImageElement;
    let boots = document.querySelector('.eo-ppd-boots') as HTMLImageElement;
    let weapon = document.querySelector('.eo-ppd-weapon') as HTMLImageElement;
    let shield = document.querySelector('.eo-ppd-shield') as HTMLImageElement;
    let quiver = document.querySelector('.eo-ppd-quiver') as HTMLImageElement;
    let quiverUnder = document.querySelector('.eo-ppd-quiver-under') as HTMLImageElement;

    race.onload = () => race.style.display = '';
    hair.onload = () => hair.style.display = '';
    hat.onload = () => hat.style.display = '';
    hatUnder.onload = () => hatUnder.style.display = '';
    clothing.onload = () => clothing.style.display = '';
    boots.onload = () => boots.style.display = '';
    weapon.onload = () => weapon.style.display = '';
    shield.onload = () => shield.style.display = '';
    quiver.onload = () => quiver.style.display = '';
    quiverUnder.onload = () => quiverUnder.style.display = '';

    function update_image(element: HTMLImageElement, type: string, ...args: any[]) {
        let gender = (document.querySelector('.js-eo-ppd-select-gender') as HTMLSelectElement).value;
        let direction = (document.querySelector('.js-eo-ppd-select-direction') as HTMLSelectElement).value;
        element.setAttribute('src', `/assets/eo/${eo_version}/${type}/${args.join('-')}-${gender}-${direction}.png`);
        element.setAttribute('data-gender', gender);
        element.setAttribute('data-direction', direction);
        setTimeout(() => {
            if(!element.complete) {
                element.style.display = 'none';
            }
        },1);
    }

    function update_race_image() {
        let raceVal = (document.querySelector('.js-eo-ppd-select-race') as HTMLSelectElement).value;
        update_image(race,'race',raceVal);
    }

    function update_hair_image() {
        let hairVal = (document.querySelector('.js-eo-ppd-select-hair') as HTMLSelectElement).value;
        let colorVal = (document.querySelector('.js-eo-ppd-select-color') as HTMLSelectElement).value;
        update_image(hair,'hair',hairVal,colorVal);
    }

    function update_hat_image() {
        let hatVal = (document.querySelector('.js-eo-ppd-select-hat') as HTMLSelectElement).value;
        update_image(hat,'hat',hatVal,0);
        update_image(hatUnder,'hat',hatVal,1);
    }

    function update_clothing_image() {
        let clothingVal = (document.querySelector('.js-eo-ppd-select-clothing') as HTMLSelectElement).value;
        update_image(clothing,'clothing',clothingVal);
    }

    function update_boots_image() {
        let bootsVal = (document.querySelector('.js-eo-ppd-select-boots') as HTMLSelectElement).value;
        update_image(boots,'boots',bootsVal);
    }

    function update_weapon_image() {
        let weaponVal = (document.querySelector('.js-eo-ppd-select-weapon') as HTMLSelectElement).value;
        update_image(weapon,'weapon',weaponVal);
    }

    function update_shield_image() {
        let shieldVal = (document.querySelector('.js-eo-ppd-select-shield') as HTMLSelectElement).value;
        update_image(shield,'shield',shieldVal);
        update_image(quiver,'quiver',shieldVal,0);
        update_image(quiverUnder,'quiver',shieldVal,1);
    }
}
